/* GSAP Animations - Save as assets/gsap-animations.js */

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger, TextPlugin);

// Animation configuration
const animationConfig = {
  ease: {
    smooth: "power2.out",
    bounce: "back.out(1.7)",
    elastic: "elastic.out(1, 0.3)",
    gentle: "power1.out"
  },
  duration: {
    fast: 0.6,
    normal: 0.8,
    slow: 1.2,
    micro: 0.3
  },
  stagger: {
    fast: 0.1,
    normal: 0.15,
    slow: 0.2
  }
};

// Initialize animations when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Remove loading class
  document.body.classList.remove('gsap-loading');
  
  initializeAnimations();
  initializeScrollAnimations();
  initializeHoverAnimations();
  initializeSpecialEffects();
});

// Core Animation Functions
function initializeAnimations() {
  
  // Heading Reveals
  gsap.utils.toArray('.gsap-heading-reveal').forEach(heading => {
    gsap.fromTo(heading, {
      opacity: 0,
      y: 30,
      filter: 'blur(3px)'
    }, {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      duration: animationConfig.duration.normal,
      ease: animationConfig.ease.smooth,
      scrollTrigger: {
        trigger: heading,
        start: "top 90%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Subtext Enter
  gsap.utils.toArray('.gsap-subtext-enter').forEach(text => {
    gsap.fromTo(text, {
      opacity: 0,
      y: 20,
      scale: 0.98
    }, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: animationConfig.duration.normal,
      ease: animationConfig.ease.gentle,
      scrollTrigger: {
        trigger: text,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Caption Fade
  gsap.utils.toArray('.gsap-caption-fade').forEach(caption => {
    gsap.fromTo(caption, {
      opacity: 0
    }, {
      opacity: 1,
      duration: animationConfig.duration.fast,
      ease: animationConfig.ease.gentle,
      scrollTrigger: {
        trigger: caption,
        start: "top 80%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Button Ready
  gsap.utils.toArray('.gsap-button-ready').forEach(button => {
    gsap.fromTo(button, {
      opacity: 0,
      scale: 0.95
    }, {
      opacity: 1,
      scale: 1,
      duration: animationConfig.duration.fast,
      ease: animationConfig.ease.bounce,
      scrollTrigger: {
        trigger: button,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Image Emerge
  gsap.utils.toArray('.gsap-image-emerge').forEach(image => {
    gsap.fromTo(image, {
      opacity: 0,
      scale: 1.05
    }, {
      opacity: 1,
      scale: 1,
      duration: animationConfig.duration.slow,
      ease: animationConfig.ease.smooth,
      scrollTrigger: {
        trigger: image,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Card Lift
  gsap.utils.toArray('.gsap-card-lift').forEach(card => {
    gsap.fromTo(card, {
      opacity: 0,
      y: 25
    }, {
      opacity: 1,
      y: 0,
      duration: animationConfig.duration.normal,
      ease: animationConfig.ease.smooth,
      scrollTrigger: {
        trigger: card,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Icon Pop
  gsap.utils.toArray('.gsap-icon-pop').forEach(icon => {
    gsap.fromTo(icon, {
      opacity: 0,
      scale: 0.9
    }, {
      opacity: 1,
      scale: 1,
      duration: animationConfig.duration.fast,
      ease: animationConfig.ease.elastic,
      scrollTrigger: {
        trigger: icon,
        start: "top 80%",
        toggleActions: "play none none reverse"
      }
    });
  });
}

// Section and Grid Animations
function initializeScrollAnimations() {
  
  // Section Enter
  gsap.utils.toArray('.gsap-section-enter').forEach(section => {
    const children = section.children;
    
    gsap.fromTo(children, {
      opacity: 0,
      y: 20
    }, {
      opacity: 1,
      y: 0,
      duration: animationConfig.duration.fast,
      ease: animationConfig.ease.smooth,
      stagger: animationConfig.stagger.normal,
      scrollTrigger: {
        trigger: section,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Grid Cascade
  gsap.utils.toArray('.gsap-grid-cascade').forEach(grid => {
    const items = grid.children;
    
    gsap.fromTo(items, {
      opacity: 0,
      y: 30,
      scale: 0.95
    }, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: animationConfig.duration.normal,
      ease: animationConfig.ease.smooth,
      stagger: animationConfig.stagger.fast,
      scrollTrigger: {
        trigger: grid,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Feature Flow
  gsap.utils.toArray('.gsap-feature-flow').forEach(container => {
    const features = container.children;
    
    gsap.fromTo(features, {
      opacity: 0,
      x: -20
    }, {
      opacity: 1,
      x: 0,
      duration: animationConfig.duration.fast,
      ease: animationConfig.ease.gentle,
      stagger: animationConfig.stagger.slow,
      scrollTrigger: {
        trigger: container,
        start: "top 80%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Scroll Gentle
  gsap.utils.toArray('.gsap-scroll-gentle').forEach(element => {
    gsap.fromTo(element, {
      opacity: 0,
      y: 30
    }, {
      opacity: 1,
      y: 0,
      duration: animationConfig.duration.normal,
      ease: animationConfig.ease.smooth,
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Scroll Scale
  gsap.utils.toArray('.gsap-scroll-scale').forEach(element => {
    gsap.fromTo(element, {
      opacity: 0,
      scale: 0.95
    }, {
      opacity: 1,
      scale: 1,
      duration: animationConfig.duration.normal,
      ease: animationConfig.ease.smooth,
      scrollTrigger: {
        trigger: element,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  });

  // Parallax Subtle
  gsap.utils.toArray('.gsap-parallax-subtle').forEach(element => {
    gsap.to(element, {
      yPercent: -10,
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
    });
  });
}

// Hover and Interactive Animations
function initializeHoverAnimations() {
  
  // Hover Lift
  gsap.utils.toArray('.gsap-hover-lift').forEach(element => {
    element.addEventListener('mouseenter', () => {
      gsap.to(element, {
        y: -5,
        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
        duration: animationConfig.duration.micro,
        ease: animationConfig.ease.smooth
      });
    });
    
    element.addEventListener('mouseleave', () => {
      gsap.to(element, {
        y: 0,
        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
        duration: animationConfig.duration.micro,
        ease: animationConfig.ease.smooth
      });
    });
  });

  // Hover Glow
  gsap.utils.toArray('.gsap-hover-glow').forEach(element => {
    element.addEventListener('mouseenter', () => {
      gsap.to(element, {
        scale: 1.02,
        boxShadow: "0 0 20px rgba(255, 137, 0, 0.3)",
        duration: animationConfig.duration.micro,
        ease: animationConfig.ease.smooth
      });
    });
    
    element.addEventListener('mouseleave', () => {
      gsap.to(element, {
        scale: 1,
        boxShadow: "0 0 0px rgba(255, 137, 0, 0)",
        duration: animationConfig.duration.micro,
        ease: animationConfig.ease.smooth
      });
    });
  });
}

// Special Effects
function initializeSpecialEffects() {
  
  // Focus Breathing
  gsap.utils.toArray('.gsap-focus-breathing').forEach(element => {
    gsap.to(element, {
      scale: 1.02,
      duration: 2,
      ease: "power1.inOut",
      yoyo: true,
      repeat: -1
    });
  });

  // Hero section special entrance
  const heroTimeline = gsap.timeline();
  if (document.querySelector('.mgc-hero-container')) {
    heroTimeline
      .fromTo('.mgc-hero-heading', {
        opacity: 0,
        y: 50,
        filter: 'blur(5px)'
      }, {
        opacity: 1,
        y: 0,
        filter: 'blur(0px)',
        duration: 1.2,
        ease: "power2.out"
      })
      .fromTo('.mgc-hero-subtitle', {
        opacity: 0,
        y: 30
      }, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out"
      }, "-=0.6")
      .fromTo('.mgc-hero-buttons', {
        opacity: 0,
        scale: 0.9
      }, {
        opacity: 1,
        scale: 1,
        duration: 0.6,
        ease: "back.out(1.7)"
      }, "-=0.4")
      .fromTo('.mgc-hero-feature', {
        opacity: 0,
        x: -20
      }, {
        opacity: 1,
        x: 0,
        duration: 0.5,
        stagger: 0.1,
        ease: "power2.out"
      }, "-=0.3");
  }

  // Tab switching animation
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mgc-tabs li a')) {
      const tabContent = document.querySelector('.mgc-tabs_item[style*="block"]');
      if (tabContent) {
        gsap.fromTo(tabContent, {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: "power2.out"
        });
      }
    }
  });
}

// Refresh ScrollTrigger on window resize
window.addEventListener('resize', () => {
  ScrollTrigger.refresh();
});

// Performance optimization: Pause animations when tab is not visible
document.addEventListener('visibilitychange', function() {
  if (document.hidden) {
    gsap.globalTimeline.pause();
  } else {
    gsap.globalTimeline.resume();
  }
});